import { useQuery } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { ApiHserviceElFindSimpleParams } from '@/apis/swaggers/v2/v2-swagger'
import { QUERY_KEY } from '@/apis/swaggers/swagger-docs'
import { QueryComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type QueryParams = QueryComposableParams<ApiHserviceElFindSimpleParams, unknown>

const fetchHServiceSimpleList = async (params: ApiHserviceElFindSimpleParams) => {
  const { data } = await apiClient.v2.apiHserviceElFindSimple(params);
  return checkApiResponse(data);
}

export const hserviceSimpleKeys = {
  all: [QUERY_KEY.v2apiHserviceElFindSimple] as const,
  list: (params: ApiHserviceElFindSimpleParams) => [...hserviceSimpleKeys.all, params] as const,
}

/** 명령형(await) 호출용 쿼리 정의 — `queryClient.fetchQuery(hserviceFindSimpleQueryOptions(params))` */
export const hserviceFindSimpleQueryOptions = (params: ApiHserviceElFindSimpleParams) => ({
  queryKey: hserviceSimpleKeys.list(params),
  queryFn: () => fetchHServiceSimpleList(params),
})

export const useHServiceFindSimpleQuery = ({ params, options }: QueryParams) => {
  return useQuery(() => ({
    queryKey: hserviceSimpleKeys.list(resolveMaybeGetter(params)),
    queryFn: () => fetchHServiceSimpleList(resolveMaybeGetter(params)),
    ...resolveMaybeGetter(options ?? {}),
  }))
}
